import React from 'react';
import AdminElectricalStylePricingEditor from './AdminElectricalStylePricingEditor';

const SERVICES = {
  134: { name: 'CCTV Installation' },
  135: { name: 'Consumer Unit Replacement' },
  136: { name: 'EICR Inspection' },
  137: { name: 'Electrical Installation' },
};

const AdminElectricalPricingRules = ({ isTabMode = false }) => (
  <AdminElectricalStylePricingEditor
    services={SERVICES}
    title="Electrical & Smart Systems Pricing Rules"
    description="Manage pricing for 4 electrical services"
  />
);

export default AdminElectricalPricingRules;
